module.exports = __webpack_public_path__ + "static/img/mail3.181edc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mail3.jpg
// module id = vXkI
// module chunks = 1